import { render, staticRenderFns } from "./ReglementModule.vue?vue&type=template&id=5d67f638&"
import script from "./ReglementModule.vue?vue&type=script&lang=js&"
export * from "./ReglementModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d67f638')) {
      api.createRecord('5d67f638', component.options)
    } else {
      api.reload('5d67f638', component.options)
    }
    module.hot.accept("./ReglementModule.vue?vue&type=template&id=5d67f638&", function () {
      api.rerender('5d67f638', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/reglements/ReglementModule.vue"
export default component.exports